import {
  UPLOADIMAGE,
  CREATEBODY,
  CREATEBODYPLUTOS,
  CREATEHEADER,
  SAVECAMPAIGNID,
  GETDATA,
  CREATEFOOTER,
  GETDATAHEADER,
  UPDATEIMAGE,
  UPDATEBODY,
  UPDATEFOOTER,
  DELETEALL,
  GETPERTICULAR,
  GETFOOTER,
  GETIMAGES,
} from "../actions/actionTypes";

const initialState = {
  imageURI: null,
  uiType: null,
  campaignId: null,
  data: [],
  dataAll: null,
  delete: [],
  perticular: [],
  footerData: [],
  imagesFetch:{}
};

export default function addCampaignReducer(state = initialState, action) {
  const { type, payload } = action;


  switch (type) {
    case UPLOADIMAGE:
      return {
        ...state,
        imageURI: payload,
      };
    case UPDATEIMAGE:
      return {
        ...state,
        imageURI: payload,
      };
    case CREATEHEADER:
      return {
        ...state,
        uiType: payload.data.ui_type,
      };
    case CREATEBODY:
      return {
        ...state,
      };
    case CREATEBODYPLUTOS:
      return {
        ...state,
      };
    case CREATEFOOTER:
      return {
        ...state,
      };
    case SAVECAMPAIGNID:
      return {
        ...state,
        campaignId: payload,
      };
    case GETDATA:
      return {
        ...state,
        data: payload.data,
      };
    case GETIMAGES:
      return {
        ...state,
        imagesFetch: payload.data,
      };
    case GETDATAHEADER:
      return {
        ...state,
        dataAll: payload.data,
      };
    case UPDATEBODY:
      return {
        ...state,
      };
    case UPDATEFOOTER:
      return {
        ...state,
      };
    case DELETEALL: {
      return {
        ...state,
      };
    }
    case GETPERTICULAR: {
      return {
        ...state,
        perticular: payload,
      };
    }
    case GETFOOTER: {
      return {
        ...state,
        footerData: payload,
      };
    }
    default:
      return state;
  }
}
